import axios from 'axios'

import {
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  OWNER_LOGIN_REQUEST,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAIL,
  OWNER_LOGIN_RESET,
  OWNER_DETAILS_FAIL,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS,
  OWNER_DETAILS_RESET,
  OWNER_PROFILE_REQUEST,
  OWNER_PROFILE_SUCCESS,
  OWNER_PROFILE_FAIL,
  OWNER_UPDATE_PROFILE_REQUEST,
  OWNER_UPDATE_PROFILE_SUCCESS,
  OWNER_UPDATE_PROFILE_FAIL
} from '../constants/ownerConstants'

import { API_URL } from '../apiUrl.js'

// Action creator for owner registration, handling the request, success, and failure states.
export const registerOwner = (ownerinfo) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_REGISTER_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/register`,
      ownerinfo,
      config
    )

    dispatch({
      type: OWNER_REGISTER_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_REGISTER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Action creator for owner login, handling the request, success, and failure states.
export const loginOwner = (email, password) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_LOGIN_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/login`,
      { email, password },
      config
    )

    dispatch({
      type: OWNER_LOGIN_SUCCESS,
      payload: data
    })

    localStorage.setItem('ownerInfo', JSON.stringify(data))
  } catch (e) {
    dispatch({
      type: OWNER_LOGIN_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Action creator for fetching owner details by ID, handling the request, success, and failure states.
export const getOwnerDetails = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_DETAILS_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/owners/${id}`, config)

    dispatch({
      type: OWNER_DETAILS_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_DETAILS_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Action creator for fetching active owner profile.
export const getOwnerProfile = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_PROFILE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/owners/profile`, config)

    dispatch({
      type: OWNER_PROFILE_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Action creator for updating active owner profile.
export const updateOwnerProfile = (owner) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_UPDATE_PROFILE_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(`${API_URL}/owners/profile`, owner, config)

    dispatch({
      type: OWNER_UPDATE_PROFILE_SUCCESS,
      payload: data
    })

    dispatch({
      type: OWNER_LOGIN_SUCCESS,
      payload: data
    })

    localStorage.setItem('ownerInfo', JSON.stringify(data))
  } catch (e) {
    dispatch({
      type: OWNER_UPDATE_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Action creator for owner logout, clearing relevant state and making a logout request to the server.
export const logoutOwner = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  localStorage.removeItem('ownerInfo')
  localStorage.removeItem('qrcodeScan')
  dispatch({ type: OWNER_LOGIN_RESET })
  dispatch({ type: OWNER_DETAILS_RESET })

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    await axios.post(`${API_URL}/owners/logout`, { id }, config)
  } catch (e) {
    console.error('Logout failed:', e)
  }
}
